<template>
  <div class="container">
    <typeList />
    <div v-loading="isLoading" class="my-table">
      <div
        class="table-item"
        v-for="(item, index) in list"
        :key="index"
        @click="toDetail(item)"
      >
        <div class="table-item-top">
          <div class="img">
            <img :src="item.ImgPath" alt="" @error="imgError" />
          </div>
        </div>
        <div class="content ellipsis2">{{ item.Title }}</div>
        <div class="table-item-bottom">
          <p class="ClassifyName">#{{ item.ClassifyName }}</p>
          <p class="PropValue">
            报名起止日期：<span class="EnrollTime">{{ item.EnrollTime }}</span>
          </p>
        </div>
      </div>
    </div>
    <el-empty
      description="暂无内容"
      :image="empty1"
      v-if="list.length == 0 && !isLoading"
    />
    <el-pagination
      class="center my-pagination mt30 mb70"
      @current-change="(page) => getList(page)"
      background
      hide-on-single-page
      :page-size="15"
      layout="prev, pager, next"
      :total="count"
    >
    </el-pagination>
  </div>
</template>

<script>
import { Enroll_GetList } from "@/api/apipcEnroll";
import typeList from "./child/typeList.vue";
export default {
  name: "apipcEnroll",
  components: {
    typeList,
  },
  data() {
    return {
      isLoading: false,
      title: "",
      PageIndex: 1,
      list: [],
      count: 0,
    };
  },
  watch: {
    $route: {
      deep: true,
      handler(v) {
        this.getList();
      },
    },
  },

  created() {
    this.getList();
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        path: "/apipcEnrollDetail",
        query: { SubjectID: item.SubjectID },
      });
    },
    async getList(page = 1) {
      if (this.isLoading) {
        return;
      }
      this.PageIndex = page;
      this.isLoading = true;
      this.list = [];
      await Enroll_GetList({
        PageIndex: this.PageIndex,
        PageSize: 15,
        ...this.$route.query,
      })
        .then((res) => {
          this.list = res.data;
          this.count = res.count;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.my-table {
  margin: 20px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  .table-item {
    cursor: pointer;
    width: 340px;
    // height: 410px;
    padding: 15px;
    background: #ffffff;
    border-radius: 10px;
    &:hover {
      transform: scale(1.01);
    }
    .table-item-top {
      .img {
        width: 308px;
        height: 231px;
        border-radius: 6px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          border-radius: 6px;
        }
      }
    }
    .content {
      margin-top: 15px;
      height: 52PX;
      font-size: 20PX;
      color: #333333;
      display: -webkit-box;
      overflow: hidden; /* 超出的文本隐藏 */
      text-overflow: ellipsis; /* 溢出用省略号显示 */
      -webkit-box-orient: vertical; /* 垂直排列子元素 */
      -webkit-line-clamp: 2; /* 显示的行数 */
    }
    .table-item-bottom {
      margin-top: 20px;
      .ClassifyName {
        font-size: 16PX;
        color: #999999;
        margin-top: 10px;
      }
      .PropValue {
        margin-top: 5px;
        font-size: 16PX;
        color: #999999;
        .EnrollTime {
          font-weight: bold;
          font-size: 16PX;
          color: #1d79ff;
        }
      }
    }
  }
}
</style>
